import React from "react";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="section" id="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <div>
            <p className="about-text">
              Accredited by the ISO 9001-2015 Certification, ABBOTT MUSIC
              STUDIO is the only sound production facility in Pakistan with
              an excellent environment that promotes ideation. Artists can
              practice, conceive, create, develop and conceptualize their
              masterpiece in a natural environment, surrounded by whispering
              pine trees. ABBOTT MUSIC STUDIO provides a complete package for
              all kinds of audio-visual productions. The facility also
              provides accommodation and mess facility to the visiting
              artists.
            </p>
          </div>
          <img
            src="/Control-room-optimized.jpg"
            alt="Abbott Music Studio Control Room"
            className="about-image"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
